import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { id: "container" }
const _hoisted_3 = {
  key: 0,
  id: "main-content-port"
}
const _hoisted_4 = { class: "" }
const _hoisted_5 = {
  class: "w100 llgreyBg",
  style: {"height":"40px"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"w100 pad20\"><div class=\"header_title fs20 fw600\">セキュリティ</div><div class=\"fs14 mt20\"> 保存するデータを安全に管理するために、利用シーンに合わせて設定が可能です。 </div></div><div class=\"clear\"></div><br><div class=\"clear\"></div>", 4)
const _hoisted_13 = {
  key: 0,
  class: "w90 pad15 mt20"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30 pad10" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "管理用メールアドレスを設定"),
  /*#__PURE__*/_createElementVNode("p", { class: "mt30" }, [
    /*#__PURE__*/_createTextVNode(" 以下のケースで担当者以外のメールアドレスにCCで送信することができます。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 半角カンマ（,）で複数のメールアドレスを入力できます。 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" ・外部カレンダー連携が外れた場合"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" ・Zoom連携が外れた場合"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" ・調整相手へのメール送信に失敗した場合"),
    /*#__PURE__*/_createElementVNode("br")
  ])
], -1)
const _hoisted_15 = { class: "fl w65" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_20 = { class: "w100 mt40 mb20" }
const _hoisted_21 = { class: "mt40 pad20" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18 fl",
  style: {}
}, "IPアドレス制限", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_24 = {
  class: "fl ml2 w100",
  style: {}
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "w30 fl" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "fs12 fl dgrey",
    style: {}
  }, [
    /*#__PURE__*/_createTextVNode(" アクセス可能なIPアドレスを設定できます。その他のIPアドレスからアクセスがあった場合、「見つかりません」のページを返します。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 入力はカンマ（,）つなぎで有効です。 ")
  ])
], -1)
const _hoisted_26 = {
  class: "w70 fl",
  style: {}
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "orange" }, "※ 範囲指定をする場合は、IPアドレス末尾に「/（スラッシュ）」とサブネットマスクのビット数を付与してください。", -1)
const _hoisted_28 = { class: "mt40 pad20" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18 fl alertRed",
  style: {}
}, "データ削除", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_31 = {
  class: "fl ml2 w100",
  style: {}
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "w30 fl" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "fs12 fl dgrey",
    style: {}
  }, " 過去に作成された調整ページ、調整相手の情報、その他調整ページに紐づく個人情報が紐づく履歴をすべて削除します。 ")
], -1)
const _hoisted_33 = {
  class: "w70 fl",
  style: {}
}
const _hoisted_34 = {
  key: 1,
  class: "pad20"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "w100 pad20" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header_title fs20 fw600" }, "アクセスログ"),
  /*#__PURE__*/_createElementVNode("div", { class: "fs14 mt20" }, "直近のログイン履歴を最大100件表示しています。")
], -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_37 = {
  key: 0,
  class: "pad10"
}
const _hoisted_38 = {
  key: 2,
  class: "pad20"
}
const _hoisted_39 = { class: "w100 pad20" }
const _hoisted_40 = { class: "header_title fs20 fw600" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "fl mt12" }, "操作ログ", -1)
const _hoisted_42 = { class: "fs14 ml20 fl" }
const _hoisted_43 = {
  key: 0,
  class: "fs14 ml20 fl mt17"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "fs14 mt20" }, [
  /*#__PURE__*/_createTextVNode(" 直近の操作履歴を50件表示しています。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", { class: "fs12" }, [
    /*#__PURE__*/_createTextVNode(" 確認できる操作履歴"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" ・調整ページの作成・更新"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" ・調整ページのダウンロード"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" ・公開ページの編集権限の共有および削除"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" ・公開ページのオーナー変更のリクエスト"),
    /*#__PURE__*/_createElementVNode("br")
  ])
], -1)
const _hoisted_46 = { class: "centered pageNation" }
const _hoisted_47 = { class: "fl" }
const _hoisted_48 = { class: "fl ml20" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_50 = {
  key: 0,
  class: "pad10"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3_progress_bar = _resolveComponent("vue3-progress-bar")!
  const _component_FlashNotice = _resolveComponent("FlashNotice")!
  const _component_ChukaiSidebarMenu = _resolveComponent("ChukaiSidebarMenu")!
  const _component_AccountHeader = _resolveComponent("AccountHeader")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_IconLock = _resolveComponent("IconLock")!
  const _component_OneLogContent = _resolveComponent("OneLogContent")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_OptionModal = _resolveComponent("OptionModal")!
  const _component_AlertModal = _resolveComponent("AlertModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_vue3_progress_bar),
    _createVNode(_component_FlashNotice),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_ChukaiSidebarMenu, { currentPage: `account` }),
      (_ctx.rm.userInfo)
        ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
            _createElementVNode("section", _hoisted_4, [
              _createVNode(_component_AccountHeader, {
                selectedTab: _ctx.selectedTab,
                ref: "header"
              }, null, 8, ["selectedTab"]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: _normalizeClass(`fs12 mt2 fl pointer pad10 ml20 ${_ctx.selectedCategory == `settings` ? `fw600 selected` : ``}`),
                  style: {"width":"120px"},
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectCategory(`settings`)))
                }, " 設定 ", 2),
                _createElementVNode("div", {
                  class: _normalizeClass(`fs12 mt2 fl pointer pad10 ${_ctx.selectedCategory == `access_logs` ? `fw600 selected` : ``}`),
                  style: {"width":"140px"},
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectCategory(`access_logs`)))
                }, " アクセスログ ", 2),
                _createElementVNode("div", {
                  class: _normalizeClass(`fs12 mt2 fl pointer pad10 ${_ctx.selectedCategory == `operation_logs` ? `fw600 selected` : ``}`),
                  style: {"width":"140px"},
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectCategory(`operation_logs`)))
                }, " 操作ログ ", 2),
                _hoisted_6
              ]),
              _hoisted_7,
              (_ctx.selectedCategory == `settings`)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _hoisted_9,
                    (_ctx.ug)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_13, [
                          _hoisted_14,
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_component_MdTextfieldTag, {
                              name: "",
                              style: {"height":"56px","max-width":"320px"},
                              class: "fs14",
                              placeholder: "メールアドレスを入力",
                              value: _ctx.ug.user_group_setting.admin_emails,
                              onInputValue: _ctx.inputAdminEmails
                            }, null, 8, ["value", "onInputValue"]),
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("button", {
                                type: "submit",
                                class: "pointer centered circle_button skyblueBg fs16 rad8 mt15 ml20",
                                style: {"width":"100px","height":"50px","padding":"14px 8px"},
                                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.saveAdminEmails && _ctx.saveAdminEmails(...args)))
                              }, " 保存 ")
                            ]),
                            _hoisted_17
                          ]),
                          _hoisted_18
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_19,
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        (!_ctx.canUseIp)
                          ? (_openBlock(), _createBlock(_component_IconLock, {
                              key: 0,
                              style: {"margin-top":"2px"},
                              class: "ml10 fl",
                              width: 16
                            }))
                          : _createCommentVNode("", true),
                        _hoisted_23,
                        _createElementVNode("div", _hoisted_24, [
                          _hoisted_25,
                          _createElementVNode("div", _hoisted_26, [
                            _createVNode(_component_MdTextfieldTag, {
                              fieldStyle: "min-width:180px;",
                              style: {"height":"56px","margin-top":"-24px"},
                              class: "fl fs16",
                              type: `ip_addresses_whitelist`,
                              placeholder: `12.12.12.12/24`,
                              value: (_ctx.ipAddresses || []).join(`,`),
                              onInputValue: _ctx.inputIPWhitelist,
                              onClickTextfield: _ctx.clickTextfield,
                              maxLength: 10000,
                              min: 3,
                              required: ""
                            }, null, 8, ["placeholder", "value", "onInputValue", "onClickTextfield"]),
                            (_ctx.canUseIp)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "submit",
                                  class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15 mr20",
                                  style: {"height":"50px"},
                                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.saveIPAddresses && _ctx.saveIPAddresses(...args)))
                                }, " 保存 "))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _hoisted_27
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        (!_ctx.canUseDeleteAllDependent)
                          ? (_openBlock(), _createBlock(_component_IconLock, {
                              key: 0,
                              style: {"margin-top":"2px"},
                              class: "ml10 fl",
                              width: 16
                            }))
                          : _createCommentVNode("", true),
                        _hoisted_30,
                        _createElementVNode("div", _hoisted_31, [
                          _hoisted_32,
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("button", {
                              type: "submit",
                              class: "pointer centered circle_button alertRedAround fs16 rad8 mt15 ml20",
                              style: {"height":"50px"},
                              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.deleteAllDependent && _ctx.deleteAllDependent(...args)))
                            }, " 削除 ")
                          ])
                        ])
                      ])
                    ])
                  ]))
                : (_ctx.selectedCategory == `access_logs`)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _hoisted_35,
                      _hoisted_36,
                      (_ctx.logs)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logs, (log, logindex) => {
                              return (_openBlock(), _createElementBlock("div", { key: logindex }, [
                                _createVNode(_component_OneLogContent, {
                                  users: _ctx.users,
                                  log: log
                                }, null, 8, ["users", "log"])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_ctx.selectedCategory == `operation_logs`)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _hoisted_41,
                            _createElementVNode("div", _hoisted_42, [
                              _createVNode(_component_SelectTag, {
                                name: "operation_log_type",
                                id: "operation_log_type",
                                class: "fl fs14 roundForm noBorder",
                                style: {"min-width":"30px","height":"50px"},
                                options: _ctx.SelectUtil.operationLogTypes.map(type => type.name),
                                defaultOption: _ctx.currentOperationLogType,
                                onSelectValue: _ctx.selectOperationLogType
                              }, null, 8, ["options", "defaultOption", "onSelectValue"])
                            ]),
                            (_ctx.currentPage)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(_ctx.currentPage) + "ページ", 1))
                              : _createCommentVNode("", true),
                            _hoisted_44
                          ]),
                          _hoisted_45,
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("div", _hoisted_47, [
                              (_ctx.currentPage > 1)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15 mr20",
                                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.getPrevOperationLogs && _ctx.getPrevOperationLogs(...args)))
                                  }, " < 前へ "))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_48, [
                              (_ctx.currentPage < _ctx.totalPages)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15 mr20",
                                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.getNextOperationLogs && _ctx.getNextOperationLogs(...args)))
                                  }, " 次へ > "))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _hoisted_49,
                        (_ctx.operationLogs)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.operationLogs, (log, logindex) => {
                                return (_openBlock(), _createElementBlock("div", { key: logindex }, [
                                  _createVNode(_component_OneLogContent, {
                                    users: _ctx.users,
                                    log: log
                                  }, null, 8, ["users", "log"])
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_51
    ]),
    _createVNode(_component_OptionModal, {
      ref: "OptionModal",
      eventName: _ctx.optionEventName,
      onClickOK: _ctx.clickOK,
      onClickCancel: _ctx.clickCancel
    }, null, 8, ["eventName", "onClickOK", "onClickCancel"]),
    _createVNode(_component_AlertModal, {
      ref: "AlertModal",
      title: _ctx.alertDic ? _ctx.alertDic.title : ``,
      text: _ctx.alertDic ? _ctx.alertDic.text : ``,
      okButtonName: _ctx.alertDic ? _ctx.alertDic.buttonName : ``,
      eventName: _ctx.optionEventName,
      onClickOK: _ctx.clickDeleteData,
      onClickCancel: _ctx.clickCancel
    }, null, 8, ["title", "text", "okButtonName", "eventName", "onClickOK", "onClickCancel"])
  ]))
}